<template>
  <div>
    <div>
      <label class="p-label" v-text="label"/>
    </div>

    <Textarea :value="value"
              @input="inputComment"
              type="text"
              style="width: 100%;
              resize: none"
              rows="5"
              maxlength="1024"
    />
  </div>
</template>

<script>
export default {
  name: 'InputComment',
  props: {
    value: String,
    label: String,
    validator: Object
  },
  methods: {
    inputComment(event) {
      this.$emit('input', event)
    }
  }
}
</script>
